let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("599FF")).then(() => parcelRequire('iKECB'));